// Copyright (c) StrangeBee 2024

import DisplayLoading from '@Atoms/Display/DisplayLoading/DisplayLoading';
import React, { ReactElement } from 'react';
import { useIsFetching } from 'react-query';

const GlobalFetchingIndicator = (): ReactElement => {
    const isGlobalFetching = useIsFetching();

    return <DisplayLoading isLoading={!!isGlobalFetching} count={isGlobalFetching} />;
};

export default GlobalFetchingIndicator;
